import find from 'lodash.find';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import { ArrowLink } from '../Links';
import * as styles from './Carousel.module.css';
import CarouselListItem from './CarouselListItem';

const isElementVisible = (element, offset = 0) => {
  if (!element || typeof window === 'undefined') {
    return false;
  }

  const bounding = element.getBoundingClientRect();
  return bounding.top - offset <= 0 && bounding.top * -1 < bounding.height + offset;
};

class ListCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.rotateRate = 8000;
    this.visibleOffset = 200;
    this.visibleRef = React.createRef();

    this.state = {
      selectedItem: null,
      showTimerProgress: true,
      refIsVisible: false,
      beginTimer: false,
    };

    this.onTick = this.onTick.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    this.setState({ selectedItem: get(this, 'props.items[0].contentful_id', {}) });
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    clearInterval(this.progress);
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  onScroll() {
    if (!this.state.refIsVisible && isElementVisible(this.visibleRef.current, this.visibleOffset)) {
      this.setState({
        refIsVisible: true,
      });

      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', this.onScroll);
      }
      this.setState({ beginTimer: true });

      this.timer = setInterval(async () => {
        this.onTick();
      }, this.rotateRate);
    }
  }

  async onTick() {
    await this.setState({ beginTimer: false });

    const { items } = this.props;

    let next = 0;
    for (let i = 0; i < items.length; i++) {
      if (!items[i] || i + 1 === items.length) {
        break;
      }

      if (items[i].contentful_id === this.state.selectedItem) {
        next = ++i;
        break;
      }
    }

    this.setState({
      selectedItem: items[next].contentful_id,
      beginTimer: true,
    });
  }

  async onSelect(selectedItem) {
    clearInterval(this.timer);
    this.setState({ selectedItem, beginTimer: false, showTimerProgress: false });
  }

  render() {
    const { selectedItem } = this.state;
    const { items, heading, eyebrowText, accentColor, onCta, ctaUrl, ctaLabel } = this.props;
    const selected = find(items, (item) => item.contentful_id === selectedItem);

    const carouselItem = items.map((item, i) => {
      const isSelected = item.contentful_id === selectedItem;

      return (
        <CarouselListItem
          key={i}
          contentful_id={item.contentful_id}
          heading={item.title}
          description={item.copy}
          showTimerProgress={this.state.showTimerProgress}
          isSelected={isSelected}
          rotateRate={this.rotateRate}
          begin={this.state.beginTimer}
          number={String(i + 1).padStart(2, '0')}
          onSelect={this.onSelect}
        />
      );
    });

    let image;
    if (selected) {
      image = <img src={get(selected, 'mainImage.file.url')} alt="" />;
    }

    return (
      <>
        {eyebrowText && (
          <div className={[styles.eyebrowText, accentColor ? styles[accentColor] : ''].join(' ')}>{eyebrowText}</div>
        )}
        <h3 className={styles.mainHeading}>{heading}</h3>
        <div ref={this.visibleRef} className={styles.carousel}>
          <div className={styles.content}>
            <ul>{carouselItem}</ul>
            {ctaLabel && !ctaUrl && (
              <div className={styles.cta}>
                <ArrowLink label={ctaLabel} onClick={onCta} />
              </div>
            )}
            {ctaLabel && ctaUrl && (
              <div className={styles.cta}>
                <ArrowLink label={ctaLabel} url={ctaUrl} />
              </div>
            )}
          </div>
          <div className={styles.image}>{selected && image}</div>
        </div>
      </>
    );
  }
}

ListCarousel.propTypes = {
  items: PropTypes.array,
  heading: PropTypes.string,
  eyebrowText: PropTypes.string,
  accentColor: PropTypes.string,
  subheading: PropTypes.string,
  onCta: PropTypes.func,
  ctaUrl: PropTypes.string,
  ctaLabel: PropTypes.string,
};

ListCarousel.defaultProps = {
  items: [],
};

export default ListCarousel;
